import React from 'react';
import {useEffect} from 'react';
import {useViewport} from 'react-viewport-hooks';

import {latestStore, systemStore} from '../stores';

import useStores from './useStores';
import ScrollRow from './ScrollRow';

const STORES = [latestStore, systemStore];

function renderRadioItem(value, label, thumbnailSize) {
  return (
    <label>
      <input type="radio" name="dpi" value={value}
        checked={thumbnailSize === value}
        onChange={() => {
          latestStore.updateThumbnailSize(value);
        }} />
      {label + ' (' + value + ')'}
    </label>
  );
}

function Latest() {
  useStores(STORES);
  // On initial render, load the data
  useEffect(() => {
    latestStore.loadData();
    return () => {latestStore.unloadData()};
  });

  const windowWidth = systemStore.getWindowWidth();
  const pixelRatio = systemStore.getPixelRatio();
  const thumbnailSize = latestStore.getThumbnailSize();
  const {vw,vh} = useViewport();
  latestStore.setWindowWidth(vw);


  let rowData = [];
  const nrRows = latestStore.getNrRows();
  for (let rowNr = 0; rowNr < nrRows; rowNr++) {
    const key = latestStore.getRowKey(rowNr, windowWidth, thumbnailSize);
    rowData[rowNr] = <ScrollRow key={key} rowNr={rowNr} isLast={rowNr === (nrRows - 1)} thumbnailSize={thumbnailSize} />;
  }

  return (
    <div>
      <h1>Latest Photos</h1>
      <p>
        Developing the display of the photo archive with the most recent photos
        first. Some information for debugging purposes:
      </p>
      <ul>
        <li>Window width: {windowWidth}</li>
        <li>Pixel ratio: {pixelRatio}</li>
        <li>Viewport: {vw} x {vh}</li>
      </ul>
      <p>
        Right now, the list of photos is a hard-coded test list.
      </p>
      <p>
        Select the desired thumbnail size, which will change the way the photos
        are rendered in rows:<br/>
        {renderRadioItem(50, 'Tiny', thumbnailSize)} {' '}
        {renderRadioItem(100, 'Small', thumbnailSize)} {' '}
        {renderRadioItem(150, 'Medium', thumbnailSize)} {' '}
        {renderRadioItem(250, 'Large', thumbnailSize)} {' '}
        {renderRadioItem(400, 'X-Large', thumbnailSize)} {' '}
      </p>
      <div>
        {
          rowData
        }
      </div>
    </div>
  );
}

export default Latest;
